import { Box, styled } from '@mui/material';

export const TwoPaneLayoutContainer = styled(Box)`
  display: flex;
  flex: 1;
  overflow: hidden;
  gap: 32px;
  max-height: 87vh;
`;

export const SidePaneContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  // MUI collapsable list are rendering unnecessary X axis scrollbar
  // To prevent this behavior, we are hiding the overflow for all children except the first one.
  // This exception is made because SearchBarWithBadges is an overflowing component.
  overflow-x: hidden;

  & > div {
    overflow: visible;
  }
`;

export const MainPaneContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 3.25; // Value set to match design spec
  overflow: hidden;
`;
